import Vue from 'vue';
import AjaxUtils from "../../util/ajax_utils";
import Store from "../../data/store";
import $ from "jquery";
import * as d3 from 'd3';
import { CRITICAL, HIGH, MEDIUM, LOW, INFO } from "../../util/colour";

export const ApckAssetsRiskPyramid = {
    props: {
        riskScore: {
            type: Number,
            default: 1,
        },
        useCritical: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            color: {
                critical: CRITICAL,
                high: HIGH,
                medium: MEDIUM,
                low: LOW,
                info: INFO
            }
        };
    },
    methods: {
        highlightRisk(scoreLevel) {
            let cmp = this;
            return (cmp.riskScore == scoreLevel) ? 'risk-active' : '';
        },
    },
    template: `
        <div class="apck-asset-risk-pryamid">
            <svg
                v-if="useCritical"
                width="100%"
                height="100%"
                viewBox="0 0 120 120"
                xmlns="http://www.w3.org/2000/svg"
            >
                <!-- Top layer (Critical) -->
                <polygon
                    :class="['segment', 'risk-critical', highlightRisk(5)]"
                    points="60,10 50,29 70,29"
                    :fill="color.critical"
                />

                <!-- Top layer (High) -->
                <polygon
                    :class="['segment', 'risk-high', highlightRisk(4)]"
                    points="50,30 70,30 80,49 40,49"
                    :fill="color.high"
                />
            
                <!-- Second layer (Medium) -->
                <polygon
                    :class="['segment', 'risk-medium', highlightRisk(3)]"
                    points="40,50 80,50 90,69 30,69"
                    :fill="color.medium"
                />

                <!-- Third layer (Low) -->
                <polygon
                    :class="['segment', 'risk-low', highlightRisk(2)]"
                    points="30,70 90,70 100,89 20,89"
                    :fill="color.low"
                />

                <!-- Bottom layer (Info) -->
                <polygon
                    :class="['segment', 'risk-info', highlightRisk(1)]"
                    points="20,90 100,90 110,110 10,110"
                    :fill="color.info"
                />

                <!-- These are so useful for debugging, the path -->
                <!--
                <line x1="60" y1="10" x2="110" y2="110" stroke="black" />
                <line x1="60" y1="10" x2="10" y2="110" stroke="black" />
                -->
        
            </svg>
            <svg
                v-if="!useCritical"
                width="100%"
                height="100%"
                viewBox="0 0 120 120"
                xmlns="http://www.w3.org/2000/svg"
            >
                <!-- Top layer (High) -->
                <polygon
                    :class="['segment', 'risk-high', highlightRisk(4)]"
                    points="60,10 48,33 72,33"
                    :fill="color.high"
                />
            
                <!-- Second layer (Medium) -->
                <polygon
                    :class="['segment', 'risk-medium', highlightRisk(3)]"
                    points="48,35 72,35 84,58 36,58"
                    :fill="color.medium"
                />

                <!-- Third layer (Low) -->
                <polygon
                    :class="['segment', 'risk-low', highlightRisk(2)]"
                    points="35,60 85,60 96,83 24,83"
                    :fill="color.low"
                />

                <!-- Bottom layer (Info) -->
                <polygon
                    :class="['segment', 'risk-info', highlightRisk(1)]"
                    points="22,85 98,85 110,110 10,110"
                    :fill="color.info"
                />

                <!-- These are so useful for debugging, the path -->
                <!--
                <line x1="60" y1="10" x2="110" y2="110" stroke="black" />
                <line x1="60" y1="10" x2="10" y2="110" stroke="black" />
                -->
            </svg>
        </div>
    `
};

export const ApckAssetAttackSurface = {
    components: {
        'risk-score': ApckAssetsRiskPyramid
    },
    props: {
        graphDataUrl: {
            type: String,
            default: '/asm/fetch',
            required: false
        },
        nodeDataUrl: {
            type: String,
            default: '/asm/details',
            required: false
        }
    },
    data: function() {
        return {
            group_size: {
                'target': 40,
                'host': 30,
                'ip': 24,
                'port':20,
                'cpe':16
            },
            group_distance: {
                host: {
                    target: 130
                },
                ip: {
                    target: 130,
                    host: 90
                },
                port: {
                    ip: 70
                },
                cpe: {
                    port: 50
                }
            },
            group_force: {
                "host": -300,
                "ip": -300
            },
            zoomControl: null,
            d3SVG: null,
            nodesGroup: null,
            highlightRisks: true,
            nodePanelVisible: false,
            activeNode: {}
        };
    },
    methods: {
        createGraph: function() {
            {
              const data = {
                name: "Attack Surface",
                children: [
                  {
                    name: "UK",
                    children: [
                      {
                        name: "appcheck-ng.com",
                        children: [
                          {
                            name: "IP 178.62.3.251",
                            children: [
                              {
                                name: "Port 433",
                                children: [
                                  { name: "Certificate, Expires 16-10-2024" },
                                  { name: "Protocol HTTP" },
                                  { name: "Software Nginx", children: [{ name: "CVE-2021-1234", children: [{ name: "Risk High" }] }] },
                                  { name: "Software Wordpress", children: [{name: "http://appcheck-ng.com/"}]}
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              };

              const width = 960;
              const height = 600;

              const svg = d3.select("#graph").append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", "translate(40,0)");

              const treeLayout = d3.tree().size([height, width - 160]);

              const root = d3.hierarchy(data);
              treeLayout(root);

              // Nodes
              svg.selectAll(".node")
                .data(root.descendants())
                .enter().append("circle")
                .attr("class", "node")
                .attr("cx", d => d.y)
                .attr("cy", d => d.x)
                .attr("r", 5);

              // Links
              svg.selectAll(".link")
                .data(root.links())
                .enter().append("line")
                .attr("class", "link")
                .attr("x1", d => d.source.y)
                .attr("y1", d => d.source.x)
                .attr("x2", d => d.target.y)
                .attr("y2", d => d.target.x);

              // Labels
              svg.selectAll(".label")
                .data(root.descendants())
                .enter().append("text")
                .attr("class", "label")
                .attr("x", d => d.y)
                .attr("y", d => d.x)
                .attr("dy", 3)
                .attr("dx", 8)
                .text(d => d.data.name);
            }
        },
        fetchGraphData: function() {
            let cmp = this;
            let url = this.graphDataUrl;
            AjaxUtils.ajax_get({
                url: url,
                success: function (data) {
                    console.log(data);
                    if(data.group_size) {
                        cmp.group_size = data.group_size;
                    }
                    if(data.group_distance) {
                        cmp.group_distance = data.group_distance;
                    }
                    if(data.group_force) {
                        cmp.group_force = data.group_force;
                    }
                    cmp.createForceGraph(data);
                },
                fail: function (data) {
                    console.log('failed');
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    flash_404_errors: false
                }
            });
        },
        fetchHostData: function(host) {
            let cmp = this;
            let url = `${cmp.nodeDataUrl}/${host}`;

            AjaxUtils.ajax_get({
                url: url,
                success: function (data) {
                    console.log(data);
                    cmp.activeNode = data;
                },
                fail: function (data) {
                    console.log('failed');
                },
                opts: {
                    dataType: 'json',
                    flash_form_errors: false,
                    flash_404_errors: false
                }
            });
        },
        processFilters: function(defs) {
            // This filter tints white/light grays to a chosen color.
            defs.append("filter")
                .attr("id", "colorise-red") // pick an ID
                .append("feColorMatrix")
                .attr("type", "matrix")
                /* 
                  For grayscale images, this matrix can push all brightness into R or G or B.
                  Below example creates a red tint. You can tweak these values or 
                  define multiple filters (one per color).
                  
                  Each row: [R, G, B, A, offset]
                */
                .attr("values", 
                   //  R    G    B    A    offset
                  "1    0    0    0    0  " + 
                  "0    0.2  0    0    0  " +
                  "0    0    0.2  0    0  " +
                  "0    0    0    1    0"
                );
        },
        groupColour: function(group) {

        },
        groupSize: function(group) {
            let cmp = this;
            
            let _node_size = cmp.group_size[group];
            if(_node_size) {
                return _node_size;
            }
            return 24;
        },
        groupDistance: function(target, source) {
            let cmp = this;
            let _default = 80;
            const targetRules = cmp.group_distance[target] || {};

            // Check specific source if it exists, 
            // otherwise use default
            return targetRules[source] || _default;
        },
        groupForce: function(group) {
            let cmp = this;
            
            let _node_force = cmp.group_force[group];
            if(_node_force !== undefined) {
                return _node_force;
            }
            return -600;
        },
        wh: function() {
            const width = $('#graph').width();
            const height = $('#graph').height();
            return [width, height];
        },
        riskText: function(risk) {
            switch(risk) {
                case 1:
                    return "Info";
                case 2:
                    return "Low";
                case 3:
                    return "Medium";
                case 4:
                    return "High";
                case 5:
                    return "Critical";
            }
        },
        riskClass: function(risk) {
            let _cls = '';
            switch(risk) {
                case 1:
                    _cls = 'risk-info';
                break;
                case 2:
                    _cls = 'risk-low';
                break;
                case 3:
                    _cls = 'risk-medium';
                break;
                case 4:
                    _cls = 'risk-high';
                break;
                case 5:
                    _cls = 'risk-critical';
                break;
            }
            return _cls;
        },
        zoomIn: function(){
            let cmp = this;
            cmp.d3SVG.transition().call(cmp.zoomControl.scaleBy, 1.3);
        },
        zoomOut: function() {
            let cmp = this;
            cmp.d3SVG.transition().call(cmp.zoomControl.scaleBy, 1 / 1.3);
        },
        zoomNode: function(d) {
            let cmp = this;

            let _wh = cmp.wh();

            let width = _wh[0];
            let height = _wh[1];

            // Decide on a desired scale (zoom factor)
            const scale = 1.5;

            let offset = 0;

            let panel = document.querySelector('.node-panel');
            if(panel) {
                let _panel_rect = panel.getBoundingClientRect();
                offset = _panel_rect.width;
            }

            // Compute the translation to place (d.x, d.y) in the center
            // The formula: [ (width/2) - (scale * d.x), (height/2) - (scale * d.y) ]
            const translate = [
                (width - offset) / 2 - scale * d.x,
                height / 2 - scale * d.y
            ];

            // Animate the transition over, 800 ms
            cmp.d3SVG.transition()
                .duration(800)
                .call(
                    cmp.zoomControl.transform, 
                    d3.zoomIdentity
                        .translate(translate[0], translate[1])
                        .scale(scale)
                );
        },
        zoomReset: function() {
            let cmp = this;
            cmp.d3SVG.transition()
                .duration(800) // animate over 800ms
                .call(cmp.zoomControl.transform, d3.zoomIdentity);
        },
        toggleRisk: function() {
            let cmp = this;
            cmp.highlightRisks = !cmp.highlightRisks;
        },
        clearSelectedNode: function() {
            Array.from(document.querySelectorAll('g.node')).forEach(
                (el) => el.classList.remove('selected')
            );
        },
        toggleNodePanel: function() {
            let cmp = this;
            cmp.nodePanelVisible = !cmp.nodePanelVisible;
        },
        closeNodePanel: function() {
            let cmp = this;
            cmp.nodePanelVisible = false;
            cmp.clearSelectedNode();
            cmp.zoomReset();
        },
        createForceGraph: function(data) {
            /* NODE DATA EXAMPLE
            {
                "colour": "#FF0000",
                "image": "/assets/images/asm/port.png",
                "group": "port",
                "id": "ca4c871a0016630773d0e3465505d9cb9b028a59c92f9c85e25e89ad7e57b27d",
                "label": "Port 8081",
                "icon": "" // utf8 font awesome text,
                "risk": 1 //1->4 (5 in the future for critical)
            }
            */
            let cmp = this;
            let _wh = cmp.wh();

            let width = _wh[0];
            let height = _wh[1];
            
            const svg = d3.select("#graph").append("svg")
                .attr("width", "100%")
                .attr("height", height);

            cmp.d3SVG = svg;

            const defs = svg.append("defs");

            //Add the defs to support rendering
            cmp.processFilters(defs);

            const color = d3.scaleOrdinal(d3.schemeCategory10);

            const chartRoot = svg.append("g")
                .attr("class", "root");

            // Define the D3 zoom behavior
            // scaleExtent limits how far users can zoom in or out
            const zoomBehavior = d3
                .zoom()
                .scaleExtent([0.1, 4]) // Min scale 0.1x, max scale 4x
                .on("zoom", (event) => {
                    // The "zoom" event gives us an event.transform
                    // which includes x, y (for panning) and k (for zoom level).
                    chartRoot.attr("transform", event.transform);
                });

            // Attach the zoom behavior to the SVG
            // so that mouse wheel, drag, or pinch gestures change the chart
            svg.call(zoomBehavior);
            //Set global to control
            cmp.zoomControl = zoomBehavior;

            const simulation = d3.forceSimulation(data.nodes)
                .force("link", d3.forceLink(data.links)
                    .id(d => d.id)
                    .distance(link => {
                        return cmp.groupDistance(link.target.group, link.source.group);
                    })
                )
                .force("charge", d3.forceManyBody()
                    .strength(d => {
                        return cmp.groupForce(d.group);
                    })
                )
                /*
                .force("radial", d3.forceRadial(d => {
                        if (d.group === "host") {
                            return 200;
                        }
                        if (d.group === "ip") {
                            return 200;
                        }
                    }, width/2, height/2)
                )
                */
                .force("center", d3.forceCenter(width / 2, height / 2))
                .force("collide", d3.forceCollide(30)); // Prevents overlap

            const link = chartRoot.append("g")
                .attr("class", "links")
                .selectAll("line")
                .data(data.links)
                .enter().append("line")
                .attr("class", "link")
                .attr("stroke-width", 2)
                .attr("stroke", "#444");

            // Create a group for each node
            const nodesGroup = chartRoot.append("g")
                .attr("class", "nodes");
            cmp.nodesGroup = nodesGroup;

            const node = nodesGroup.selectAll(".node")
                .data(data.nodes)
                .enter().append("g")
                .attr("class", d => {
                    return `node node-type-${d.group}`;
                })
                .call(d3.drag()
                    .on("start", dragstarted)
                    .on("drag", dragged)
                    .on("end", dragended)
                );

            // Append a circle behind each node
            // adjust the radius, fill, and stroke
            node.append("circle")
                .attr("r", d => {
                    return cmp.groupSize(d.group);
                })
                .attr("class", d => {
                    let cls = `node-border-${d.group}`;
                    if(d.risk && d.risk > 1) {
                        cls = cls + ' ' + cmp.riskClass(d.risk);
                    }
                    return cls;
                })
                .attr("fill", "#fff")
                .attr("stroke", d => d.colour || "#000")  // use node.colour if provided
                .attr("stroke-width", 2);

            // Append image if available
            node.filter(d => d.icon)
                .append("text")
                .attr("class", "fa-icon node-icon")
                .text(d => {return '\uf57d';})
                .attr("width", d => {
                    return (cmp.groupSize(d.group) -4);
                })
                .attr("height", d => {
                    return (cmp.groupSize(d.group) -4);
                })
                .attr("font-size", d => {
                    return (cmp.groupSize(d.group) -4);
                })
                .attr("x", d => {
                    return -((cmp.groupSize(d.group) -4) / 2);
                })
                .attr("y", d => {
                    return -((cmp.groupSize(d.group) -4) / 2);
                });

            // Append image if available
            node.filter(d => d.image && !d.icon)
                .append("image")
                .attr("class", "node-image")
                .attr("xlink:href", d => d.image)
                .attr("width", d => {
                    return (cmp.groupSize(d.group) -4);
                })
                .attr("height", d => {
                    return (cmp.groupSize(d.group) -4);
                })
                .attr("x", d => {
                    return -((cmp.groupSize(d.group) -4) / 2);
                })
                .attr("y", d => {
                    return -((cmp.groupSize(d.group) -4) / 2);
                });

            const nodeText = node.append("g")
                .attr("class", "node-text-hover")
                .attr("dy", d => (cmp.groupSize(d.group) / 2) + 30);

            // Insert an empty <rect> before each text
            // This is so there is a background.
            const labelRect = nodeText.append("rect")
                .attr("fill", "#333")
                .attr("stroke", "#fff")
                .attr("stroke-width", 2);

            nodeText.append("text")
                .text(d => d.label)
                .attr("text-anchor", "middle");

            //raise on hover
            node.on("mouseover", function(event, d) {
                let _node = d3.select(this);

                _node.raise();

                let _t = _node.select('g.node-text-hover').select('text');
                _t.each(function() {
                    const bbox = this.getBBox();
                    _node.select('g.node-text-hover').select("rect")
                        .attr("x", bbox.x - 8)
                        .attr("y", bbox.y - 3)
                        .attr("width", bbox.width + 16)
                        .attr("height", bbox.height + 6)
                        .attr("rx", 10)
                        .attr("ry", 10);
                });
                    
            });

            // No specific mouseout logic needed
            node.on("mouseout", function(event, d) {
                /*
                let _t = d3.select(this).select('g.node-text-hover');
                // Hide the hover again.
                _t.each(function() {
                    this.style.display = 'none';
                });
                */
            });

            node.on("click", function(event, d){
                let _node = d3.select(this);
                //Clear all selected nodes first.
                cmp.clearSelectedNode();
                //Raise this node and mark it as selected.
                _node.raise();
                _node.node().classList.add("selected");

                cmp.nodePanelVisible = true;
                //Just set some default data while fetching.
                cmp.activeNode = {
                    risk: d.risk,
                    host: d.host
                };

                console.log(d);
                cmp.fetchHostData(d.host);

                //We want to center our node, however the panel needs to open first.
                //We do this so we give it a chance to open before getting it's width.
                setTimeout(function(){
                    cmp.zoomNode(d);
                }, 200);

                
            });

            simulation
                .nodes(data.nodes)
                .on("tick", ticked);

            simulation.force("link")
                .links(data.links);

            // Additional slight centering
            simulation
                .force("x", d3.forceX(width / 2).strength(0.1))
                .force("y", d3.forceY(height / 2).strength(0.1));

            function ticked() {
                link
                    .attr("x1", d => d.source.x)
                    .attr("y1", d => d.source.y)
                    .attr("x2", d => d.target.x)
                    .attr("y2", d => d.target.y);

                // Move each node-group as a whole
                node
                    .attr("transform", d => `translate(${d.x},${d.y})`);
            }

            function dragstarted(event, d) {
                if (!event.active) simulation.alphaTarget(0.3).restart();
                d.fx = d.x;
                d.fy = d.y;
            }

            function dragged(event, d) {
                d.fx = event.x;
                d.fy = event.y;
            }

            function dragended(event, d) {
                if (!event.active) simulation.alphaTarget(0);
                d.fx = null;
                d.fy = null;
            }
        }
    },
    mounted: function() {
        let cmp = this;
        cmp.fetchGraphData();
    },
    watch: {

    },
    template: `
        <apck-panel no-padding no-border>
            
            <div id="graph" :class="['apck-asset-attack-surface', highlightRisks ? 'show-risks' : '']">

                <div class="attack-surface-options">
                    <apck-toggle-button
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="toggleRisk"
                        title="Toggle Risks"
                        :value="highlightRisks"
                    />
                    <!--
                    <apck-toggle-button
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="toggleNodePanel"
                        title="Toggle Node Panel"
                        :value="nodePanelVisible"
                    />
                    -->
                </div>

                <div class="attack-surface-zoom-control">
                    <apck-button
                        icon="fa-magnifying-glass-plus"
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="zoomIn"
                        title="Zoom In"
                    />
                    <apck-button
                        icon="fa-magnifying-glass-minus"
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="zoomOut"
                        title="Zoom Out"
                    />
                    <apck-button
                        icon="fa-magnifying-glass-arrows-rotate"
                        class="btn-secondary"
                        span-class="req-large"
                        :handler="zoomReset"
                        title="Zoom Reset"
                    />
                </div>

                <apck-panel v-if="nodePanelVisible" class="node-panel">
                    <div class="node-panel-title">
                        <span>
                            Target: {{ activeNode.host }}
                        </span>
                        <apck-button
                            icon="fa-times"
                            class="btn-danger"
                            span-class="req-large"
                            :handler="closeNodePanel"
                            title="Close Panel"
                        />
                    </div>

                    <div class="node-panel-body">
                        <div class="risk-details">
                            <div class="risk-image">
                                <risk-score :risk-score="activeNode.risk" />
                            </div>
                            <div class="risk-text">
                                <span>
                                    Risk Score: {{ riskText(activeNode.risk) }}
                                </span>
                            </div>
                        </div>

                        <div class="host-details">

                            <div class="node-panel-section">
                                <h2>Details:</h2>
                                <span class="detail">
                                    Operating System: {{ activeNode.os }}
                                </span>
                                <span class="detail">
                                    Last Updated: {{ activeNode.lastSeen }}
                                </span>
                            </div>

                            <div v-if="activeNode.ips" class="node-panel-section">
                                <h2>IPs:</h2>
                                <div v-for="(data, ip, index) in activeNode.ips" class="node-panel-ips">
                                    <div class="ip-text">
                                        <span>
                                            {{ ip }}
                                        </span>
                                    </div>
                                    <div class="ip-ports">
                                        <span v-for="port in data.ports" :class="['risk-tag', riskClass(port.risk)]">
                                            {{ port.port }} : {{ port.protocol }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="activeNode.cves.length > 0" class="node-panel-section node-panel-cves">
                                <h2>CVEs:</h2>
                                <span v-for="cve in activeNode.cves" class="risk-tag">
                                    {{ cve }}
                                </span>
                            </div>

                            <div v-if="activeNode.vulns.length > 0" class="node-panel-section node-panel-vulns">
                                <h2>Vulnerabilities:</h2>
                                <span v-for="vuln in activeNode.vulns" :class="['risk-tag', riskClass(vuln.risk)]">
                                    {{ vuln.title }}
                                </span>
                            </div>

                        </div>
                    </div>
                </apck-panel>

            </div>

        </apck-panel>
    `
}